import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LOG_LEVEL, LoggerService } from '@app/services/util/logger.service';
import { LoginService } from '@util/login.service';

// import { AmplifyService } from 'aws-amplify-angular';

/**
 * LoginComponent
 *
 * @export LoginComponent
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  /**
   * Username used for login
   *
   * @todo Deprecate once Office 365 federation is implemented
   */
  public username: string;

  /**
   * Password used for login
   *
   * @todo Deprecate once Office 365 federation is implemented
   */
  public password: string;

  /**
   * Creates an instance of LoginComponent.
   *
   * @param router used to route the user after a successful login
   * @param loginService used to attempt login
   */
  constructor(
    private router: Router,
    private loginService: LoginService,
  ) {}

  /**
   * Attempts to redirect the user to Home (Will fail if AuthGuard Login is not valid)
   */
  ngOnInit() {
    this.loginService.checkLogin().subscribe(
      data => {
        if (data) {
          this.router.navigate(['']);
        }
      },
      error => {
        LoggerService.log(error, LOG_LEVEL.ERROR);
      },
    );
  }

  /**
   * Attempt login (currently using environment declared login variables but will be changed to 365 Login)
   */
  login() {
    this.loginService.login();
    this.router.navigate(['']);
  }

}
